module.exports = __webpack_public_path__ + "img/4-5-media-mesh-1.7fd156fd.jpg";